import { HTTP, authHeader } from './http-service';

class DataSubjectAccessRequestNoteService {
  notesList(dsarId) {
    return HTTP.get(`/DataSubjectAccessRequestNote/dsar/${dsarId}`, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  get(dsarId, dsarInternalNoteId) {
    return HTTP.get(`/DataSubjectAccessRequestNote/${dsarInternalNoteId}/dsar/${dsarId}/`, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  create(payload) {
    return HTTP.post(`/DataSubjectAccessRequestNote`, payload, { headers: authHeader() }).then(
      (response) => {
        return response.data;
      },
    );
  }

  update(payload) {
    return HTTP.put(`/DataSubjectAccessRequestNote`, payload, { headers: authHeader() }).then(
      (response) => {
        return response.data;
      },
    );
  }

  delete(payload) {
    return HTTP.delete(
      `/DataSubjectAccessRequestNote/${payload.dsarInternalNoteId}/dsar/${payload.dsarId}`,
      {
        headers: authHeader(),
      },
    ).then((response) => {
      return response.data;
    });
  }
}

export default new DataSubjectAccessRequestNoteService();
